import * as featuredSponsoredCardActions from '../../action_creators/homepage/featured_sponsored_card_action_creators';
import FeaturedSponsoredCardModel from '../../../models/homepage/featured_sponsored_card_module';
import log from '../../../services/logger_service';

export default function fetchPostDetail(params, store, isTag) {
  return function firstDispatch(dispatch) {
    dispatch(
      featuredSponsoredCardActions.featuredSponsoredCardLoading({}, store)
    );
    return FeaturedSponsoredCardModel.fetch(params, store, isTag)
      .then(function handlePostDetailData(resp) {
        dispatch(
          featuredSponsoredCardActions.featuredSponsoredCardLoaded(
            resp.data,
            store
          )
        );
      })
      .catch(function handleUserError(err) {
        dispatch(
          featuredSponsoredCardActions.featuredSponsoredCardLoadError(
            err,
            store
          )
        );
        log.error(
          err,
          `Error in featured sponsored card actions, message: ${err.message}`
        );
      });
  };
}
